
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Kharaditomumbaicabservice() {



    const cardData =
    {
        keyword: 'Kharadi to Mumbai Cab Service',
        heading: 'Meghana Cab : Kharadi to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Kharadi to Mumbai Cab Service, providing a reliable and efficient travel solution from Pune’s rapidly growing IT and business hub to Mumbai. Whether you are traveling for work, airport transfers, or leisure, our well-maintained fleet—including Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures a smooth and safe journey. With doorstep pickup from Kharadi, punctual service, experienced drivers, transparent pricing, and 24/7 customer support, Meghana Cab makes intercity travel easy and stress-free. Book your Kharadi to Mumbai Cab today and enjoy a comfortable ride with top-notch service.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Kharadi to Mumbai One Way Taxi",
        "description": "Book a convenient one-way taxi from Kharadi to Mumbai for personal, business, or airport travel. Enjoy door-to-door service, professional chauffeurs, clean vehicles, and punctual pickups—all at competitive prices."
    },
    {
        "name": "Round Trip Cab Kharadi to Mumbai",
        "description": "Planning a round trip? Our Kharadi to Mumbai round-trip cab service gives you the flexibility of return travel without worrying about last-minute bookings. Ideal for business meetings, events, or short getaways."
    },
    {
        "name": "Online Booking Taxi Kharadi to Mumbai",
        "description": "Reserve your taxi from Kharadi to Mumbai with our simple and secure online booking system. Get instant confirmation, transparent fares, and a range of vehicle options tailored to your travel needs."
    },
    {
        "name": "Budget Cab Hire Kharadi to Mumbai",
        "description": "Choose our budget-friendly cab hire from Kharadi to Mumbai and enjoy reliable service at low rates. Clean cars, verified drivers, and smooth travel—all without compromising on quality."
    },
    {
        "name": "AC Cab Kharadi to Mumbai",
        "description": "Beat the heat with our air-conditioned cabs from Kharadi to Mumbai. Whether it's a short trip or a highway drive, travel in total comfort with cooling interiors and well-maintained vehicles."
    },
    {
        "name": "SUV & Sedan Cabs Kharadi to Mumbai",
        "description": "Select from spacious SUVs or elegant sedans for your journey from Kharadi to Mumbai. Whether you need luggage space, group seating, or premium comfort, we have the right vehicle for every preference."
    },
    {
        "name": "Chauffeur Cab Kharadi to Mumbai",
        "description": "Our chauffeur-driven cab service offers a luxurious and relaxed travel experience from Kharadi to Mumbai. Professional, courteous drivers ensure timely travel with a customer-first approach."
    },
    {
        "name": "Family Travel Taxi Kharadi to Mumbai",
        "description": "Traveling with loved ones? Our family cab service ensures a safe, spacious, and enjoyable ride from Kharadi to Mumbai. Kid-friendly and senior-comfortable options available on request."
    },
    {
        "name": "Private Car Hire Kharadi to Mumbai",
        "description": "Enjoy the privacy and flexibility of private car hire from Kharadi to Mumbai. Skip ride-sharing hassles and travel exclusively with our discreet and reliable private transport service."
    },
    {
        "name": "24-Hour Taxi Booking Kharadi to Mumbai",
        "description": "Need a cab at odd hours? Our 24/7 taxi booking service from Kharadi to Mumbai is always ready—perfect for airport drops, late-night emergencies, or early-morning departures."
    },
    {
        "name": "Business Travel Kharadi to Mumbai Cab",
        "description": "For corporate travelers, we offer punctual, well-equipped cabs from Kharadi to Mumbai. Experience smooth journeys, professional drivers, and billing support tailored for business needs."
    },
    {
        "name": "Affordable Fare Kharadi to Mumbai Cab",
        "description": "Looking for the best price? Our affordable fare taxi service ensures value-packed travel from Kharadi to Mumbai with no hidden costs and fully transparent per-kilometer pricing."
    },
    {
        "name": "Premium Service Cab Kharadi to Mumbai",
        "description": "Opt for premium comfort with our luxury cab service from Kharadi to Mumbai. Featuring top-tier vehicles, extra legroom, bottled water, and professional chauffeurs for an elite travel experience."
    },
    {
        "name": "Kharadi to Mumbai Express Highway Cab",
        "description": "Enjoy fast and smooth travel via the express highway from Kharadi to Mumbai. Our drivers are trained for highway safety and efficient routes, ensuring you reach your destination quickly and comfortably."
    },
    {
        "name": "Reliable Taxi Kharadi to Mumbai",
        "description": "Depend on our trusted taxi service for safe and timely travel from Kharadi to Mumbai. Our high customer satisfaction and experienced drivers make us the go-to option for regular travelers."
    }
],
"tableData": [
    ["Kharadi to Mumbai One Way Taxi", "Round Trip Cab Kharadi to Mumbai"],
    ["Online Booking Taxi Kharadi to Mumbai", "Budget Cab Hire Kharadi to Mumbai"],
    ["AC Cab Kharadi to Mumbai", "SUV & Sedan Cabs Kharadi to Mumbai"],
    ["Chauffeur Cab Kharadi to Mumbai", "Family Travel Taxi Kharadi to Mumbai"],
    ["Private Car Hire Kharadi to Mumbai", "24-Hour Taxi Booking Kharadi to Mumbai"],
    ["Business Travel Kharadi to Mumbai Cab", "Affordable Fare Kharadi to Mumbai Cab"],
    ["Premium Service Cab Kharadi to Mumbai", "Kharadi to Mumbai Express Highway Cab"],
    ["Reliable Taxi Kharadi to Mumbai", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Trusted Kharadi to Mumbai Cab Service",
        "WhyChoosedescription": "Enjoy seamless travel from Kharadi to Mumbai with our reliable cab service. Whether it’s a business trip, airport transfer, or personal journey, we ensure punctual pickups, smooth rides, and complete comfort throughout your trip."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Air-Conditioned Cabs",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles with clean interiors, efficient air-conditioning, and spacious seating. Choose from hatchbacks, sedans, SUVs, or premium cars based on your needs and preferences."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are trained professionals who are familiar with the Kharadi–Mumbai route. They prioritize safety, punctuality, and customer satisfaction, ensuring a stress-free and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our fare structure is simple and transparent. The quoted price includes all taxes, tolls, fuel, and driver allowances—so you always know exactly what you're paying for without surprise fees."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Book a one-way cab, round-trip, or hourly rental as per your convenience. We provide flexible travel plans that can be tailored to your specific schedule, with customizable pickup and drop locations."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off",
        "WhyChoosedescription": "Our service includes direct pickup from your home, office, or hotel in Kharadi and drop-off at your destination in Mumbai. Enjoy the comfort of a door-to-door travel experience without the hassle of public transport."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Family Trips",
        "WhyChoosedescription": "Whether you're heading to Mumbai Airport, a business meeting, or a family event, our cabs are suited for every purpose—offering convenience, privacy, and dependable service throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Travel Assistance",
        "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to help you with bookings, cancellations, rescheduling, or any special travel requests—ensuring a hassle-free experience every step of the way."
    }
]


























    }

const faqData = [
    {
        question: "How can I book a cab from Kharadi to Mumbai with Meghana Cab?",
        answer: "Booking is easy—just call us at +91 9075462128 or book online through our website with instant confirmation."
    },
    {
        question: "What is the typical travel duration from Kharadi to Mumbai by cab?",
        answer: "The journey usually takes around 3.5 to 4.5 hours depending on traffic conditions and time of travel."
    },
    {
        question: "Do you offer both one way and round trip services from Kharadi to Mumbai?",
        answer: "Yes, we offer both options to suit your travel needs and schedule."
    },
    {
        question: "What types of cars are available for Kharadi to Mumbai cab booking?",
        answer: "You can choose from hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and preferences."
    },
    {
        question: "Is your Kharadi to Mumbai cab service available 24/7?",
        answer: "Yes, our services are available round the clock, including late-night and early-morning travel."
    },
    {
        question: "What’s included in the fare for this route?",
        answer: "The fare includes fuel, tolls, and driver charges. Parking fees and extra waiting time may be charged separately."
    },
    {
        question: "Can I make a same-day booking from Kharadi to Mumbai?",
        answer: "Yes, same-day and even last-minute bookings are accepted subject to availability. We recommend calling for quicker service."
    },
    {
        question: "Is online booking available for this route?",
        answer: "Absolutely! You can book online 24/7 with secure payment and instant confirmation."
    },
    {
        question: "Can I schedule stops or detours during the journey?",
        answer: "Yes, you can plan stops for meals, sightseeing, or breaks—just inform us during booking."
    },
    {
        question: "Are your drivers trained and experienced for long trips?",
        answer: "Yes, our drivers are well-trained, courteous, and familiar with the Kharadi to Mumbai route for a smooth and safe journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Abhishek Rane',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made my business trip from Kharadi to Mumbai very comfortable. On-time pickup and polite driver!”',
    },
    {
        name: 'Ms. Shraddha More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly professional service from Kharadi to Mumbai. Booking was easy, and the vehicle was super clean.”',
    },
];
























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharadi to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/kharadi-to-mumbai-cab.jpg",
  "description": "Book affordable and reliable cab service from Kharadi to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available 24/7 for one-way and round trips with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/kharadi-to-mumbai-cab-service"
  }
};








    return (
        <div>

<Helmet>
  <title>Kharadi to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book affordable and reliable cab service from Kharadi to Mumbai by Meghana Cabs. Choose AC Sedans, SUVs, and chauffeur-driven cars. Available 24/7 for one-way and round trips with online booking." 
  />
  <meta 
    name="keywords" 
    content="Kharadi to Mumbai One Way Taxi, Round Trip Cab Kharadi to Mumbai, Online Booking Taxi Kharadi to Mumbai, Budget Cab Hire Kharadi to Mumbai, AC Cab Kharadi to Mumbai, SUV & Sedan Cabs Kharadi to Mumbai, Chauffeur Cab Kharadi to Mumbai, Family Travel Taxi Kharadi to Mumbai, Private Car Hire Kharadi to Mumbai, 24-Hour Taxi Booking Kharadi to Mumbai, Business Travel Kharadi to Mumbai Cab, Affordable Fare Kharadi to Mumbai Cab, Premium Service Cab Kharadi to Mumbai, Kharadi to Mumbai Express Highway Cab, Reliable Taxi Kharadi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kharaditomumbaicabservice;